import { useMutation } from "@tanstack/react-query";
import serialsClient from "../../../api/serials";

const useSerialLookup = () => {
  return useMutation({
    mutationFn: (query: string) => serialsClient.lookup(query),
  });
};

export default useSerialLookup;
